import React, { useState } from 'react';
import { Button, Carousel, Col, Container, Modal, NavLink, Row } from 'react-bootstrap';
import './ProjectModal.css';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const elementGithub = <FontAwesomeIcon icon={faGithub} />
const elementExternalLinkAlt = <FontAwesomeIcon icon={faExternalLinkAlt} />

const ProjectModal = ({ show, fullscreen, projects, setShow }) => {

    const [index, setIndex] = useState(0);
    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    return (
        <div >
            <p></p>
            <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
                <Modal.Header style={{ backgroundColor: "#0A192F", color: "white", border: "none" }} closeButton>
                    <Modal.Title style={{ color: "#CCD6F6", textAlign: "center" }}>
                        <NavLink className="ms-0" href="https://aulad-hossen-portfolio.netlify.app/" style={{ color: "#64FFDA" }}>Aulad Hossen</NavLink>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="project-detail-modal">
                    <Container className="w-50">
                        <Row>
                            <h1 style={{ color: "#64FFDA", fontWeight: "bold" }} className="text-center my-4">Drone Zilla</h1>
                            <Col md={12}>
                                <Carousel activeIndex={index} onSelect={handleSelect}>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src="https://i.ibb.co/b3DwRSv/dronezilla.png"
                                            alt="First slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src="https://i.ibb.co/gFZPCRv/drone-zilla-dashboard.png"
                                            alt="Second slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src="https://i.ibb.co/0FzfRwc/dronezilla-make-admin.png"
                                            alt="Third slide"
                                        />
                                    </Carousel.Item>
                                </Carousel>
                            </Col>
                            <Col className="paragraph-modal my-5" style={{ color: "#8892B0" }} md={12}>
                                <p>"DroneZilla" Web Application is for buying most trending drone in online platform. User can buy their desire drone from here. They can check there order list. Admin can check all the orders and can manage them.

                                </p>
                                <p className="tech">Technology: React.js &nbsp;Node.js &nbsp;MongoDB &nbsp;Firebase &nbsp;Heroku</p>
                                <p> Project Overview <br />
                                    ○ Developed for selling drones online. Implemented User Authentication, Admin System, CRUD Operation. <br />
                                    ○ Users can see details of drone products of different models, users can order drones, users can provide reviews and ratings. users can cancel their orders. <br />
                                    ○ The Prerogative for admin to add a new Drone. Admin can manage them and can make a new admin. <br />
                                </p>
                                <a href="https://drone-zilla.web.app/" target="_blank" style={{ color: "#64FFDA", fontSize: "17px", textDecoration: "none" }}>{elementExternalLinkAlt} Live Site</a> &nbsp; &nbsp;
                                <a href="https://github.com/auladhimel/droneZilla-drone-buying-client-side" target="_blank" style={{ color: "#64FFDA", fontSize: "17px", textDecoration: "none" }}>{elementGithub} Frontend Code</a> &nbsp; &nbsp;
                                <a href="https://github.com/auladhimel/droneZilla-drone-buying-client-side" target="_blank" style={{ color: "#64FFDA", fontSize: "17px", textDecoration: "none" }}>{elementGithub} Backend Code</a> &nbsp; &nbsp;
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default ProjectModal;